import { api } from '@/infra/api'
import type { ApiResponse, MessageResponse } from '@/infra/types'
import type { Account } from './schemas'

export const accountsApi = {
  async getMe(): Promise<Account> {
    const { data } = await api.get<ApiResponse<Account>>('/api/v1/accounts/me')
    if (!data.data) {
      throw new Error('No account data received')
    }
    return data.data
  },

  async deleteMe(): Promise<string> {
    const { data } = await api.delete<MessageResponse>('/api/v1/accounts/me')
    return data.message ?? 'Account deleted successfully'
  },
}
